<h2 mat-dialog-title class="dialog-title">Acuity Level Update</h2>

<div mat-dialog-content class="dialog-content">
  <p class="dialog-subtitle">Acuity Level update request for {{ data.patientName }}</p>

  <div class="level-row">
    <div class="level-column">
      <span class="level-label">Current Level</span>
      <span
        class="level-chip"
        [ngClass]="{
          'acuity-low': data.currentLevel === 'low',
          'acuity-medium': data.currentLevel === 'medium',
          'acuity-high': data.currentLevel === 'high'
        }"
      >
        {{ data.currentLevel | titlecase }} Acuity
      </span>
    </div>
    <mat-icon class="level-arrow">arrow_forward</mat-icon>
    <div class="level-column">
      <span class="level-label">Requested Level</span>
      <span
        class="level-chip"
        [ngClass]="{
          'acuity-low': data.requestedLevel === 'low',
          'acuity-medium': data.requestedLevel === 'medium',
          'acuity-high': data.requestedLevel === 'high'
        }"
      >
        {{ data.requestedLevel | titlecase }} Acuity
      </span>
    </div>
  </div>

  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

  <form [formGroup]="form" class="acuity-update-form" *ngIf="!isLoading">
    <div formArrayName="checks" class="trigger-list">
      <mat-checkbox
        *ngFor="let control of checksArray.controls; let i = index"
        [formControlName]="i"
        class="trigger-checkbox"
      >
        {{ triggers[i] }}
      </mat-checkbox>
      <p *ngIf="triggers.length === 0" class="no-triggers">No triggers available.</p>
    </div>

    <mat-form-field appearance="outline" class="comments-field">
      <mat-label>Comments</mat-label>
      <textarea matInput formControlName="comments" rows="4"></textarea>
      <mat-hint>*Required if no trigger is selected.</mat-hint>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-button type="button" (click)="onCancel()" [disabled]="isSaving">Cancel</button>
  <button
    mat-raised-button
    color="primary"
    type="button"
    [disabled]="!canSubmit || isLoading || isSaving"
    (click)="onSubmit()"
  >
    <mat-spinner *ngIf="isSaving" diameter="16" class="submit-spinner"></mat-spinner>
    <span>{{ isSaving ? 'Submitting\u2026' : 'Submit' }}</span>
  </button>
</div>
